<div class="create-cv-container">
    <div>
      <div class="create-cv-header">
        <span class="title">
            Neuen Berater CV erstellen
        </span>
        <mat-icon class="close-icon" svgIcon="close" (click)="close()"></mat-icon>
      </div>
      <div class="create-cv-body">
        <form class="create-cv-form" [formGroup]="form">
            <mat-form-field class="full-width" appearance="outline">
                <mat-select formControlName="language" matNativeControl required>
                    <mat-option *ngFor="let language of languages" [value]="language.value">{{ language.label }}</mat-option>
                </mat-select>
                <mat-error *ngIf="this.form.hasError('required', 'language')">
                    {{ 'please_select' | translate }}!
                </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width" appearance="outline">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name" autocomplete="off" type="text" minlength="3" maxlength="100" formControlName="name">
                <mat-error *ngIf="this.form.hasError('required', 'name')">
                    {{ 'required' | translate }}
                </mat-error>
                <mat-error *ngIf="this.form.hasError('minlength', 'name')">
                    {{ 'min_lenght_validation' | translate: {'number': 3} }}
                </mat-error>
                <mat-hint *ngIf="showMaxLengthWarning">{{ 'maximum_number_of_characters_reached' | translate: {'number': 100} }}</mat-hint>
            </mat-form-field>
        </form>
        
      </div>
    </div>
    <div class="action-block">
      <button class="full-width" color="primary" mat-button (click)="createCv()" [disabled]="form.invalid">CV erstellen</button>
    </div>
  </div>
  